import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import logo from "../Assets/Img/stemma.webp";
import logoServizi from "../Assets/Img/logoServizi.png";

function Footer(props) {
  const [manualOpExists, setManualOpExists] = useState(false);
  const [manualPuaExists, setManualPuaExists] = useState(false);
  const [manualAsExists, setManualAsExists] = useState(false);

  useEffect(() => {
    fetch(
      `${props.subfolder}/doc/Semplicita Ambiti Territoriali Sociali - TUTORIAL PER ASSISTENTE SOCIALE.pdf`,
      { method: "HEAD" }
    )
      .then((res) => {
        const contentLength = res.headers.get("content-length");
        setManualAsExists(
          res.status === 200 && contentLength && parseInt(contentLength) > 0
        );
      })
      .catch(() => setManualAsExists(false));
    fetch(
      `${props.subfolder}/doc/Semplicita Ambiti Territoriali Sociali - TUTORIAL PER PUA.pdf`,
      {
        method: "HEAD",
      }
    )
      .then((res) => {
        const contentLength = res.headers.get("content-length");
        setManualPuaExists(
          res.status === 200 && contentLength && parseInt(contentLength) > 0
        );
      })
      .catch(() => setManualPuaExists(false));
    fetch(
      `${props.subfolder}/doc/Semplicita Ambiti Territoriali Sociali - TUTORIAL PER UFFICIO DI PIANO.pdf`,
      { method: "HEAD" }
    )
      .then((res) => {
        const contentLength = res.headers.get("content-length");
        setManualOpExists(
          res.status === 200 && contentLength && parseInt(contentLength) > 0
        );
      })
      .catch(() => setManualOpExists(false));
  }, []);

  return (
    <footer className="it-footer">
      <div className="it-footer-main footerCustom">
        <div className="container footerText">
          <section>
            <div className="row">
              <div className="col-sm-5">
                <div className="it-brand-wrapper">
                  <a href="https://www.ambito3.it/">
                    <img alt="logo" height="82" className="mr-2" src={logo} />
                    <div className="it-brand-text">
                      <h2 className="no_toc"></h2>
                      <h3 className="no_toc"></h3>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-2">
                <div className="it-brand-wrapper">
                  {manualAsExists && (props.delegate || props.operator) && (
                    <Link
                      to="/doc/Semplicita Ambiti Territoriali Sociali - TUTORIAL PER ASSISTENTE SOCIALE.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button className="btn btn-primary ml-2 mt-3">
                        Scarica manuale assistente sociale
                      </button>
                    </Link>
                  )}
                  {manualPuaExists && (props.attivita || props.operator) && (
                    <Link
                      to="/doc/Semplicita Ambiti Territoriali Sociali - TUTORIAL PER PUA.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button className="btn btn-primary ml-2 mt-3">
                        Scarica manuale PUA
                      </button>
                    </Link>
                  )}
                  {manualOpExists && props.operator && (
                    <Link
                      to="/doc/Semplicita Ambiti Territoriali Sociali - TUTORIAL PER UFFICIO DI PIANO.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <button className="btn btn-primary ml-2 mt-3">
                        Scarica manuale Ufficio di Piano
                      </button>
                    </Link>
                  )}
                </div>
              </div>
              <div className="col-sm-5">
                <div className="it-brand-wrapper float-sm-right">
                  <a
                    href="https://servizilocalispa.com/"
                    target="_blank"
                    className="mr-1"
                  >
                    <img
                      alt="logo"
                      height="82"
                      src={logoServizi}
                      className="mr-2"
                    />
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section></section>
          {/*       <section className="py-4">
            <div className="row clearfix">
            <div className="col-lg-6 col-md-4 pb-2">
               <h6>CONTATTI</h6>
                <p>
                  Palazzo di Città | Corso Vittorio Emanuele II, 84 | 70122 Bari
                  | Italy
                  <br />
                  <strong>URP - Ufficio Relazioni con il Pubblico:</strong>
                  <br />
                  <strong>
                    080/5772390 - 080/5772391 - 800/018291 (solo da telefono
                    fisso)
                  </strong>{" "}
                  <br />
                  Centralino: +39 080 577 1111
                  <br />
                  CF: 80015010723 - P.IVA: 00268080728
                  <br />
                  Per l'elenco delle PEC: Indice delle Pubbliche Amministrazioni
                  <br />
                </p>
              </div>
              <div className="col-lg-3 col-md-4 pb-2">
                <h6>SOCIAL</h6>
                <p>
                  <a
                    target="_blank"
                    href="https://it.linkedin.com/company/servizi-locali-spa"
                  >
                    <svg className="icon icon-white borderCircle">
                      <use href={`${iconSprite}#it-linkedin`} />
                    </svg>
                  </a>
                </p>
                <p>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/servizilocalispa.it"
                  >
                    <svg className="icon icon-white borderCircle">
                      <use href={`${iconSprite}#it-facebook`} />
                    </svg>
                  </a>
                </p>
              </div>
            </div>
          </section> */}

          <section className="py-2 border-white border-top">
            <div className="row clearfix">
              <div className="col-lg-4 py-2">
                <h3 className="sr-only">Sezione Link Utili</h3>
                <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
                  <li className="list-inline-item">
                    {/*
                  <a
                      href="#"
                      className="small-prints text-white"
                      title="Privacy-Cookies"
                      target="_blank"
                    >
                      Privacy policy
                    </a> 
                   
                   
                   */}
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <div className="row">
            <div className="col-12 text-center">
              <p>
                Powered by Servizi Locali S.P.A. • Copyright © 2025 • All rights
                reserved.
              </p>
            </div>
          </div>
          <div className="cookiebar">
            <p>
              Questo sito utilizza solo cookie tecnici. <br />
              Per maggiori informazioni consulta la nostra Privacy Policy.
            </p>
            <div className="cookiebar-buttons">
              <a href="#" target="_blank" className="cookiebar-btn">
                Privacy policy<span className="sr-only">cookies</span>
              </a>
              <button
                data-accept="cookiebar"
                className="cookiebar-btn cookiebar-confirm"
              >
                Accetto<span className="sr-only"> i cookies</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
export const MemoizedFooter = React.memo(Footer);
